import { Component } from '@angular/core';

@Component({
  selector: 'app-pin-manager',
  templateUrl: './pin-manager.component.html',
  styleUrls: ['./pin-manager.component.css']
})
export class PinManagerComponent {

}
